define('modules/form_editor/models/form_element_factory',['require','exports','module','./input_text','./input_textarea','./check_group','./radio_group','./dropdown','./input_hidden','./custom_privacy','./custom_terms','./custom_telephone','./custom_email','./custom_date','./custom_date_amp','./custom_gender','./custom_password','./custom_iban','./custom_day','./custom_month','./custom_year','./custom_fblogin','./custom_linlogin','./custom_google_recaptcha','./custom_separator'],function (require, exports, module) {
  "use strict";
  /*
  Factory to create specific models based on the control type, used
  in the fields collection
  */
  var ElementMapping = {
    "input:text":             require("./input_text"),
    "input:textarea":         require("./input_textarea"),
    "input:checkgroup":       require("./check_group"),
    "input:radiogroup":       require("./radio_group"),
    "input:dropdown":         require("./dropdown"),
    "input:hidden":           require("./input_hidden"),
    "custom:privacy":         require("./custom_privacy"),
    "custom:terms":           require("./custom_terms"),
    "custom:telephone":       require("./custom_telephone"),
    "custom:email":           require("./custom_email"),
    "custom:date":            require("./custom_date"),
    "custom:date_amp":        require("./custom_date_amp"),
    "custom:gender":          require("./custom_gender"),
    "custom:password":        require("./custom_password"),
    "custom:iban":            require("./custom_iban"),
    "custom:day":             require("./custom_day"),
    "custom:month":           require("./custom_month"),
    "custom:year":            require("./custom_year"),
    "custom:login:facebook":  require("./custom_fblogin"),
    "custom:login:linkedin":  require("./custom_linlogin"),
    "custom:captcha:google_recaptcha":  require("./custom_google_recaptcha"),
    "custom:separator":       require("./custom_separator")
  };

  var Serialization = {
    fromJSON: function(json){
      // backwards compatibility, delete after some time
      if (json.name === "custom:fblogin") json.name = "custom:login:facebook";
      return _.extend(
        module.exports.createElement(json.name, _.omit(json, "name")));
    }
  };

  module.exports = {
    createElement: function(name, options){
      var ElementConstructor = ElementMapping[name];
      if(ElementConstructor){
        return new ElementConstructor(_.extend({ name: name}, options));
      }
      else {
        throw new Error("No form field constructor for name " + name);
      }
    },
    fromJSON: Serialization.fromJSON
  };

});

